import { render } from "./DeviceLabel.vue?vue&type=template&id=16287b8e&ts=true"
import script from "./DeviceLabel.vue?vue&type=script&lang=ts"
export * from "./DeviceLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__